/**
 * Icon Component - Component Definition
 * =====================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { IconController } from './controller';
import { ICON_TEMPLATE } from './template';
import { SIZE_CLASSES, VALID_SIZES, DEFAULTS } from './constants';

export interface IEcIconComponentBindings {
  name?: string;
  variant?: string;
  size?: string;
  ariaLabel?: string;
}

export const iconComponentDefinition: IComponentOptions = {
  template: ICON_TEMPLATE,
  controller: IconController,
  bindings: {
    name: '@',
    variant: '@',
    size: '@',
    ariaLabel: '@'
  }
};

export const MODULE_NAME = 'ec.icon';

const iconModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecIcon', iconComponentDefinition);

export { IconController, ICON_TEMPLATE, SIZE_CLASSES, VALID_SIZES, DEFAULTS };
export type { IconSize } from './constants';
export default iconModule;
